// extracted by mini-css-extract-plugin
export default {"container":"VersionForm_container__+MhfN","field-container":"VersionForm_field-container__HDIka","text-input":"VersionForm_text-input__zUj4T","label":"VersionForm_label__uJfNV"};